module.exports = __webpack_public_path__ + "img/report_cover.31bb043e.png";